import { render, staticRenderFns } from "./DistributedColumns.vue?vue&type=template&id=35a55b60&"
import script from "./DistributedColumns.vue?vue&type=script&lang=js&"
export * from "./DistributedColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports